import React from 'react'
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
const GridLoadingSkeleton = ({ variant, marginy, marginx, rows, count, height, width }) => {
    return (

        <Stack >
            {[...Array(rows ? rows : 1)].map((index, value) => (

                <Box
                    key={`grid-skeleton-row-${value}`}

                    sx={{
                        height: "max-content",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        p: 1,
                        m: 1,
                        bgcolor: "background.paper",
                    }} >


                    {[...Array(count ? count : 1)].map((index, value) => (
                        <Skeleton
                            key={`grid-skeleton-row-item-${value}`}
                            variant={variant}
                            sx={{
                                my: marginy ? marginy : null,
                                mx: marginx ? marginx : null
                            }}
                            height={height ? height : null}
                            width={width ? width : null}
                        />
                    ))}

                </Box>
            ))}

        </Stack>
    )
}

export default GridLoadingSkeleton